import { combineReducers } from 'redux'
import { popupDataSlice } from './popupDataSlice'

/**
 * Functions used to combine the different slices
 * in which the reducers are organized
 */
const rootReducer = combineReducers({
  popupData: popupDataSlice.reducer,
});


export default rootReducer